import { connect } from 'react-redux'
import FontFace from '../components/FontFace'

const mapStateToProps = state => ({
    fontFace: state.getIn(['tour', 'fontFace']),
})

export default connect(mapStateToProps)(FontFace)
